function connectMegaMenu() {
  var elements = document.querySelectorAll('[data-class]');

  elements.forEach(function (el) {
    var connectClass = el.getAttribute('data-class');

    var targetMega = document.querySelector(
      '.mega-menu[data-class="' + connectClass + '"] .mega-wrapper'
    );

    var sourceMega = document.querySelector(
      '.connect-mega[data-class="' + connectClass + '"]'
    );

    if (targetMega && sourceMega) {
      var children = Array.from(sourceMega.children);

      if (children.length) {
        targetMega.innerHTML = '';
        children.forEach(child => targetMega.appendChild(child));
        sourceMega.remove();
      }
    }
  });
}
function init() {
  connectMegaMenu();
}
document.addEventListener('DOMContentLoaded', init);
document.addEventListener('shopify:section:load', init);
document.addEventListener('shopify:section:select', init);
